<template>
  <div>
    <div :class="`flex flex-column ${header.toLowerCase()}`" v-if="holeScores">
      <div :class="[itemHeaderClass, 'hole-header-background']">{{ header.toUpperCase() }}</div>
      <div :class="`${itemHeaderClass} ${$vuetify.theme.dark ? '' : 'item-handicap'}`">
        &hyphen;
      </div>
      <div class="item item-par bold">
        {{ sumOfArray(holePars, begin, end) }}
      </div>

      <!-- Scramble Team scores -->
      <div v-for="(i, x) in scrambleTeamsTotal" :key="`6${i}`">
        <transition name="fadeDown" mode="out-in" appear v-if="isScramble">
          <div :class="`item bold ${$vuetify.theme.dark ? '' : 'item-score'}`">
            <!-- {{ x }}
            {{ scrambleTeamScores[x] }} -->
            {{ sumOfArray(scrambleTeamScores[x], begin, end) | checkGrossScore }}
          </div>
        </transition>
      </div>

      <!-- score -->
      <transition name="fadeDown" mode="out-in" appear v-if="!isScramble && !isBestBall">
        <div :class="`item bold ${$vuetify.theme.dark ? '' : 'item-score'}`">
          {{ sumOfArray(holeScores, begin, end) | checkGrossScore }}
        </div>
      </transition>
      <!-- net -->
      <transition name="fadeDown" mode="out-in" appear v-if="!isScramble && !isBestBall">
        <div :class="`item bold item-round-score ${$vuetify.theme.dark ? '' : ''}`">
          {{ sumOfArray(holeNetScores, begin, end) }}
          <!-- {{ netScoreCalc(sumOfArray(holeScores, begin, end), userShotData.handicap) }} -->
          <!-- {{ netScoreCalc(sumOfArray(holeNetScores, begin, end), userShotData.handicap) }} -->
        </div>
      </transition>
      <!-- to par / round score / stableford points -->
      <transition name="fadeDown" mode="out-in" appear v-if="!isScramble && !isBestBall">
        <div class="item item-round-score bold" v-if="hasRoundScores && !hasStablefordScores">
          {{ sumOfArray(holeRoundScores, begin, end) | checkRoundScore }}
        </div>
        <div class="item item-round-score bold" v-else-if="hasStablefordScores">
          {{ sumOfArray(stablefordScores, begin, end) }}
        </div>
        <div class="item item-round-score bold" v-else></div>
      </transition>
      <!-- Best ball team scores -->
      <transition name="fadeDown" mode="out-in" appear v-if="hasBestBallTeamScores && !isScramble">
        <div class="item item-score" v-if="hasBestBallTeamScores">
          {{ sumOfArray(bestBallTeamScores, begin, end) }}
        </div>
      </transition>
      <div
        :class="[itemHeaderClass, 'divider-header-background']"
        v-if="!isScramble && !isBestBall"
      >
        &nbsp;
      </div>
      <div :class="[itemHeaderClass]" v-if="!isScramble && !isBestBall">&nbsp;</div>
      <div class="item sand bold" v-if="!isScramble && !isBestBall">
        {{ sandShotStats(sandShots, begin, end) | percentage }}
      </div>
      <div
        :class="[itemHeaderClass, 'divider-header-background greens']"
        v-if="!isScramble && !isBestBall"
      >
        &nbsp;
      </div>
      <div class="item item-putt putts" v-if="expanded && !isScramble && !isBestBall">
        {{ sumOfArray(puttingShots, begin, end) | checkZero }}
      </div>
      <div class="item mulligans" v-if="expanded && !isScramble && !isBestBall">
        {{ sumOfArray(mulligans, begin, end) | checkZero }}
      </div>
      <div class="item penalties" v-if="expanded && !isScramble && !isBestBall">
        {{ sumOfArray(penalties, begin, end) | checkZero }}
      </div>
    </div>
  </div>
</template>

<script>
import utilityMixin from '@/mixins/utilityMixin';

export default {
  name: 'ScoreCardItemTotal',
  mixins: [utilityMixin],
  props: {
    userShotData: Object,
    header: String,
    begin: Number,
    end: Number,
    expanded: Boolean,
    gameMode: String,
  },

  computed: {
    itemHeaderClass() {
      return 'item header';
    },

    holeHandicaps() {
      if (this.utility_isObject(this.userShotData)) {
        const { holeHandicaps } = this.userShotData || {};
        return holeHandicaps ?? [];
      }
    },

    holePars() {
      if (this.utility_isObject(this.userShotData)) {
        const { holePars } = this.userShotData || {};
        return holePars ?? [];
      }
    },

    holeScores() {
      if (this.utility_isObject(this.userShotData)) {
        const { holeScores } = this.userShotData || {};
        return holeScores ?? [];
      }
    },

    holeRoundScores() {
      if (this.utility_isObject(this.userShotData)) {
        const { holeRoundScores } = this.userShotData || {};
        return holeRoundScores ?? [];
      }
    },

    holeNetScores() {
      if (this.utility_isObject(this.userShotData)) {
        const { holeNetScores } = this.userShotData || {};
        return holeNetScores ?? [];
      }
    },

    stablefordScores() {
      if (this.utility_isObject(this.userShotData)) {
        const { stablefordScores } = this.userShotData || {};
        return stablefordScores ?? [];
      }
    },

    bestBallTeamScores() {
      if (this.utility_isObject(this.userShotData)) {
        const { bestBallTeamScores } = this.userShotData || {};
        return bestBallTeamScores ?? [];
      }
    },

    teeClubs() {
      if (this.utility_isObject(this.userShotData)) {
        const { teeClubs } = this.userShotData || {};
        return teeClubs ?? [];
      }
    },

    fairwayShots() {
      if (this.utility_isObject(this.userShotData)) {
        const { fairwayShots } = this.userShotData || {};
        return fairwayShots ?? [];
      }
    },

    sandShots() {
      if (this.utility_isObject(this.userShotData)) {
        const { sandShots } = this.userShotData || {};
        return sandShots ?? [];
      }
    },

    greensInRegulation() {
      if (this.utility_isObject(this.userShotData)) {
        const { greensInRegulation } = this.userShotData || {};
        return greensInRegulation ?? [];
      }
    },

    puttingShots() {
      if (this.utility_isObject(this.userShotData)) {
        const { puttingShots } = this.userShotData || {};
        return puttingShots ?? [];
      }
    },

    mulligans() {
      if (this.utility_isObject(this.userShotData)) {
        const { mulligans } = this.userShotData || {};
        return mulligans ?? [];
      }
    },

    penalties() {
      if (this.utility_isObject(this.userShotData)) {
        const { penalties } = this.userShotData || {};
        return penalties ?? [];
      }
    },

    hasRoundScores() {
      if (this.utility_isObject(this.userShotData)) {
        const { holeRoundScores } = this.userShotData || {};
        return holeRoundScores?.length > 0 ?? false;
      }
    },

    hasStablefordScores() {
      if (this.utility_isObject(this.userShotData)) {
        const { stablefordScores } = this.userShotData || {};
        return stablefordScores?.length > 0 ?? false;
      }
    },

    isBestBall() {
      return this.gameMode?.toLowerCase().replace('_', '') === 'bestball';
    },

    hasBestBallTeamScores() {
      if (this.utility_isObject(this.userShotData)) {
        const { bestBallTeamScores } = this.userShotData || {};
        return bestBallTeamScores?.length > 0 ?? false;
      }
    },

    isScramble() {
      return this.gameMode?.toLowerCase() === 'scramble';
    },

    scrambleTeamsTotal() {
      return this.userShotData?.scrambleTeamScores?.length ?? 0;
    },

    scrambleTeamScores() {
      if (this.utility_isObject(this.userShotData)) {
        const { scrambleTeamScores } = this.userShotData || {};
        return scrambleTeamScores ?? [];
      }
    },
  },

  methods: {
    sumOfArray(arr, begin, end) {
      const slicedArray = arr?.scores ? arr?.scores?.slice(begin, end) : arr.slice(begin, end);
      const nullCheck = (currentVal) => {
        return currentVal === null || currentVal === '-';
      };
      const invalid = slicedArray.every(nullCheck);

      if (invalid) {
        return null;
      }

      return slicedArray.reduce((a, b) => {
        return a + b;
      }, 0);
    },

    sandShotStats(arr, begin, end) {
      const slicedArray = arr.slice(begin, end);

      const totalHoles = this.userShotData?.holeScores?.slice(begin, end).filter((score) => {
        return score !== null;
      });

      return totalHoles?.length > 0
        ? slicedArray.reduce((a, b) => {
            return a + b / totalHoles.length;
          }, 0)
        : 0;
    },

    netScoreCalc(gross, handicap) {
      if (gross && handicap) {
        return Math.round(gross - handicap);
      }
    },
  },

  filters: {
    percentage(v) {
      if (v === 0) return `-`;
      if (v) return `${(v * 100).toFixed(1)}%`;
      return `${v}%`;
    },

    checkZero(c) {
      if (c === 0 || c === undefined) return '-';
      return c;
    },

    checkRoundScore(s) {
      if (s === null) {
        return ``;
      }

      const sign = Math.sign(s);
      switch (sign) {
        case 0:
          return 'E';
        case 1:
          return `+${s.toFixed(0)}`;
        case -1:
          return `${s.toFixed(0)}`;
        default:
          break;
      }
    },

    checkGrossScore(s) {
      if (s === null || s === undefined) {
        return;
      }
      return s.toFixed(0);
    },
  },
};
</script>

<style scoped>
.item {
  padding: 16px 8px;
  text-align: center;
  width: 100%;
  line-height: 0;
}

.item-score {
  background-color: var(--offWhite);
}

.item-putt,
.item-par {
  border-bottom: 1px solid #6d6d6d;
  border-bottom: 1px solid var(--grey);
}

.item-round-score {
  border-top: 1px solid #6d6d6d;
  border-top: 1px solid var(--grey);
}

.item-handicap {
  background-color: var(--offWhite);
}

.header {
  font-weight: 600;
  padding: 16px 8px;
  margin-right: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hole-header-background {
  background-color: var(--grey);
  color: var(--white);
}

.divider-header-background {
  background-color: var(--grey-light);
  color: var(--white);
}

.bold {
  font-weight: 600;
}

@media screen and (max-width: 960px) {
  .item {
    padding: 8px;
  }
}
</style>
